import { render, staticRenderFns } from "./MultipleAutocompleteTreeSelector.vue?vue&type=template&id=2b056005&"
import script from "./MultipleAutocompleteTreeSelector.vue?vue&type=script&lang=js&"
export * from "./MultipleAutocompleteTreeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports